import React, { Fragment } from "react";
import { Container } from "@material-ui/core";
import { Helmet } from "react-helmet";
import { BookPurchaseBanner } from "../AuthorSubmissions/components";
import { PageBanner } from "../../components";

// const useStyles = makeStyles((theme) => ({

//     sectionHeading: {
//         fontSize: '64px',
//         color: theme.palette.secondary.light,
//         fontWeight: 700,
//         letterSpacing: 0.1,
//         margin: '0 20px',
//         lineHeight: '60px',
//         [theme.breakpoints.down('md')]:{
//             fontSize: '54px',
//         },
//         [theme.breakpoints.down('sm')]:{
//             fontSize: '45px',
//             lineHeight: '40px',
//             marginTop:'30px'
//         }
//     },
// }))

function FuturePublications() {
  return (
    <Fragment>
      <Helmet>
        <title>Future Publications - d2p</title>
      </Helmet>
      <PageBanner title="Future Publications" image="/assets/images/bg4.jpg" />
      <div style={{ margin: "70px 0" }}>
        <Container style={{ textAlign: "justify", fontSize: "18px" }}>
          <p>
            It wasn’t a dream, it was real. At thirty-five years old, my drug
            trafficking enterprise had made me a wealthy man. I had houses in
            Honolulu, Las Vegas, Atlanta, and elsewhere, I had money stashed in
            bank account in the U.S., Canada, and more than $3 million in cash
            buried in Nevada and Georgia. I owned more vehicles, boats, and
            motorcycles than I knew what to do with. I clandestinely owned a
            stake in a variety of businesses across the continent. I founded
            several companies, including Galaxie Records, which was poised to
            achieve commercial success with its debut artist, Johnny Knox, I had
            close friends, business associates, and criminal acquaintances
            across North America-from Mexico to Canada, from Honolulu to New
            York.
          </p>
          <p>
            No job, no serious responsibilities or commitments. I was free to do
            whatever I wanted. To top it off, I was engaged to my soul mate, a
            gorgeous, vibrant, and sexually charged young woman with whom I had
            known her entire life, I had it all. I was living my dreams.
          </p>
          <p>Then came the fall.</p>
          <p>
            At precisely nine o’clock on a bright and clear morning, six FBI
            agents came to my home in Las Vegas and hauled me away in handcuffs.
            A warrant had been issued for my arrest in Hawaii. A federal grand
            jury there had indicted me on trafficking charges.
          </p>
          <p>
            And so it began-my spiraling descent into a hell I’m sure most
            people think I deserved. I would experience the repeated sting of
            betrayal from those I’d once die for. I’d also suffer the loss of
            money, assets, businesses, my fiancee, my mother, and 30 years of my
            liberty following an eight-day jury trial. I’d also lose my legal
            alien status as a result of my conviction and face deportation back
            to Canada, an event that would cure my removal and permanent
            banishment from the United States, thereby preventing me from the
            access required to retrieve my buried cash. By all accounts, I was
            fucked.
          </p>
          <p>Or was I?</p>
          <p>
            While the METHod chronicles my journey from childhood to
            multi-millionaire drug trafficker. The AfterMETH chronicles my fall
            and the subsequent events that transformed my dire situation into a
            remarkable rise from the ashes.
          </p>
          <p>Revenge is a beautiful thing.</p>
          <BookPurchaseBanner />
        </Container>
      </div>
    </Fragment>
  );
}

export default FuturePublications;
